export default __webpack_public_path__ + "static/media/Manage_Appointments_Icon.b2eb05ae.svg";